import LinkButton from '@carvana/ds-link-button';
import React from 'react';
import { StepName } from '|/app/services';
import useNavigateToStep from '|/hooks/use-navigate-to-step';
import { ReviewSummaryResponse } from '|/services/purchase-api';
import styles from './how-youre-paying.module.css';
import useOrderSummaryVm from '../../use-order-summary-vm';
import LoanDetails from '../loan-details';

interface HowYourePayingProps {
  summary?: ReviewSummaryResponse;
  testId?: string;
}

const HowYourePaying = ({
  summary = {} as ReviewSummaryResponse,
  testId = 'how-youre-paying-section'
}: HowYourePayingProps) => {
  const navigateToStep = useNavigateToStep();
  const {
    isCarvanaFinancing,
    isOutsideFinance,
    isCash,
    isThirdParty,
    isDelivery,
    isCoApplicantToggleOn,
    cobuyerName,
    hasCoBuyerName,
    hasPaymentMethodBeenVerified
  } = useOrderSummaryVm(summary);

  if (!hasPaymentMethodBeenVerified) return null;

  return (
    <section data-testid={testId}>
      <h3>How you&apos;re paying</h3>
      <div className={styles.contentContainer}>
        <div className={styles.paymentGroup}>
          <h4>Payment type</h4>
          <p>{`
            ${isCarvanaFinancing ? 'Carvana financing' : ''}
            ${isOutsideFinance || isThirdParty ? 'Self-arranged financing' : ''}
            ${isCash ? 'Cash' : ''}
          `}</p>
        </div>
        {isCoApplicantToggleOn && hasCoBuyerName && (
          <div className={styles.paymentGroup}>
            <h4>Co-signer</h4>
            <p>{cobuyerName}</p>
            <p className={styles.cosignerSubtext}>
              Your co-signer must be present at the {isDelivery ? 'delivery' : 'pickup'} appointment
              with a valid ID.
            </p>
          </div>
        )}

        <LoanDetails summary={summary} />

        <div className={styles.paymentGroup}>
          <LinkButton
            size="sm"
            underline={false}
            onClick={() => {
              navigateToStep(StepName.CoF);
            }}
            data-analytics-id="pp_review_order_edit_payment_type"
            data-testid="edit-payment-type-button"
            className={styles.editButton}
          >
            Edit payment type
          </LinkButton>
        </div>
      </div>
    </section>
  );
};

export default HowYourePaying;
